module.exports = __webpack_public_path__ + "static/Customer-Experiences-88037d6d8503b227c76644524b52e3db.jpg";